import React from 'react';
import { ShieldCheck, Download } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-navy text-cream py-6 px-4 md:px-8" data-id="element-38">
      <div className="max-w-2xl mx-auto text-center" data-id="element-39">
        <div className="flex items-center justify-center space-x-2 mb-2" data-id="element-40">
          <ShieldCheck className="w-6 h-6 text-amber" data-id="element-41" />
          <h2 className="text-sm font-serif font-bold text-white" data-id="element-42">
            GARANTÍA DE 7 DÍAS
          </h2>
        </div>
        <p className="text-xs text-gray-400 mb-3" data-id="element-43">
          Si no ves resultados, te devolvemos el 100%. Sin preguntas.
        </p>
        <div className="flex items-center justify-center space-x-1.5 text-xs text-gray-500" data-id="element-44">
          <Download className="w-3.5 h-3.5 text-amber" data-id="element-45" />
          <span data-id="element-46">Producto digital para descargar</span>
        </div>
      </div>
    </section>;
}